<template>
  <div class="card card-chat-booking float-left ml-3">
    <div class="card-body">
      <div class="mb-3">
        <b>{{ message.text }}</b>
        <div class="d-flex mt-3">
          <div class="flex-fill">
            <div class="exp">
              <div class="checkbox">
                <input type="radio"
                        id="hasIroningBoard"
                        name="hasIroningBoard"
                        :value="1"
                        v-model="hasIroningBoard"
                        v-validate="'required'"/>
                <label for="hasIroningBoard" class="mb-0">
                  <span><!-- This span is needed to create the "checkbox" element --></span>
                  {{ $t('message.confirm.yes') }}
                </label>
              </div>
            </div>
          </div>
          <div class="flex-fill">
            <div class="exp">
              <div class="checkbox">
                <input type="radio"
                        id="hasNoIroningBoard"
                        name="hasIroningBoard"
                        :value="0"
                        v-model="hasIroningBoard"
                        v-validate="'required'"/>
                <label for="hasNoIroningBoard" class="mb-0">
                  <span><!-- This span is needed to create the "checkbox" element --></span>
                  {{ $t('message.confirm.no') }}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="mt-1 text-remark -status-alert" v-if="errors.has('hasIroningBoard')">
          {{ $t('message.required_selection') }}
        </div>
        <div class="pt-3">
          <button class="btn btn-info btn-block" @click="submit()">
            {{ $t('message.button.submit') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    props: {
      message: Object
    },
    data () {
      return {
        hasIroningBoard: null
      }
    },
    computed: {
      ...mapState('chatBooking', ['bookingData'])
    },
    methods: {
      async submit () {
        this.$validator.validate().then(valid => {
          if (valid) {
            let data = `has_ironing_board=${this.hasIroningBoard}`
            const message = {
              sender_type: 'user',
              type: 'text',
              label: 'selected-has-ironing-board',
              text: 'ยืนยันข้อมูลเกี่ยวกับโต๊ะรีดผ้าแล้ว',
              data: data
            }
            this.$store.commit('chatBooking/ADD_MESSAGE', message)
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/chatBooking/components/HasIroningBoardMessage.vue